// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zhH6V:hover,\n.zhH6V:active {\n  background-color: var(--surface-brand-hover) !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "zhH6V"
};
export default ___CSS_LOADER_EXPORT___;
